import React from 'react';
import { MnLoading } from '../../../index';
import { Layout, InterviewForm } from '../organisms/index';

export default class InterviewShow extends React.Component {
  render () {
    return (<React.Suspense fallback={ <MnLoading/> }>
      <Layout state={this.props}>
        <InterviewForm {...this.props} />
      </Layout>
    </React.Suspense>);
  }
}
